import { render, staticRenderFns } from "./outStockRecord.vue?vue&type=template&id=0320fb32"
import script from "./outStockRecord.vue?vue&type=script&lang=js"
export * from "./outStockRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports